import React from "react";
import "./modal.scss";

/* ----------------------------------
 * Types
 * ---------------------------------- */

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  open: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  open,
}) => {
  if (!open) return null;

  return (
    <div
      className="main-modal-overlay"
      onClick={onClose}
    >
      <div
        className="modal-container"
        onClick={(e: React.MouseEvent<HTMLDivElement>) =>
          e.stopPropagation()
        }
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
